@if (vm$ | async; as vm) {
    @if (vm.enabled) {
        <button
            type="button"
            class="service-pro-cookie-consent-button"
            [class.service-pro-cookie-consent-button--login]="isLoginPage"
            [class.service-pro-cookie-consent-button--labeled]="showLabel"
            (click)="onClick($event)"
            [attr.aria-label]="showLabel ? null : 'Åbn cookie-indstillinger'"
            data-testid="cookie-settings-button"
        >
            <mat-icon class="service-pro-cookie-consent-button__icon" svgIcon="dffedb-cookie-consent.cookie" aria-hidden="true"></mat-icon>
            @if (showLabel) {
                <span>Cookie-indstillinger</span>
            }
        </button>
    }
}
